import useI18n from '@shared/hooks/useI18n'

// HOOKS
const { t } = useI18n()

export const fabActions = {
  CALENSO_ROUTE: 'calensoRoute',
  OPEN_CHAT: 'openChat',
}

export const fabEntryName = {
  ALVA: 'alva',
  APPOINTMENT: 'appointment',
  CONTACT: 'contact',
}

export function FabEntry({ title = '', description = '', links = [new FabLink()] }) {
  this.description = description
  this.links = links
  this.title = title
}

export function FabLink({ id = '', name = '', url = '', target = '_blank', action = '', icon = undefined } = {}) {
  this.action = action
  this.icon = icon
  this.id = id
  this.name = name
  this.target = target
  this.url = url
}

const _t = {
  alva: 'fab.entries.alva',
  appointment: 'fab.entries.appointment',
  assistance: 'fab.entries.assistance',
}

const alvaLink = [
  new FabLink({
    id: 'alva',
    name: `${_t.alva}.links.alva.name`,
    target: '_self',
    url: import.meta.env.VITE_APP_AIDE_ENV,
  }),
]

export const fabEntries = (isWww, hideAide = false, existingCustomer = false) => {
  let dotcomAppointmentLink, calensoAppointmentLinks
  if (isWww) {
    dotcomAppointmentLink = [
      new FabLink({
        id: 'appointment',
        name: `${_t.appointment}.links.book.name`,
        url: t(`${_t.appointment}.links.book.url`),
      }),
    ]
  } else {
    calensoAppointmentLinks = [
      new FabLink({
        action: { name: fabActions.CALENSO_ROUTE, param: 'video' },
        icon: 'video',
        id: 'video',
        name: `${_t.appointment}.links.book.video`,
      }),
      new FabLink({
        action: { name: fabActions.CALENSO_ROUTE, param: 'personal' },
        icon: 'user-group',
        id: 'personal',
        name: `${_t.appointment}.links.book.personal`,
      }),
      new FabLink({
        action: { name: fabActions.CALENSO_ROUTE, param: 'callback' },
        icon: 'headset',
        id: 'callback',
        name: `${_t.appointment}.links.book.callback`,
      }),
    ]
  }

  const alva = new FabEntry({
    description: `${_t.alva}.description`,
    links: alvaLink,
    title: `${_t.alva}.title`,
  })

  const appointment = new FabEntry({
    description: isWww ? `${_t.appointment}.description.dotcom` : `${_t.appointment}.description.dvp`,
    links: isWww ? dotcomAppointmentLink : calensoAppointmentLinks,
    title: `${_t.appointment}.title`,
  })

  const contact = new FabEntry({
    description: `${_t.assistance}.description`,
    title: `${_t.assistance}.title`,
  })

  return {
    [fabEntryName.ALVA]: !hideAide && !existingCustomer ? alva : null,
    [fabEntryName.APPOINTMENT]: !existingCustomer ? appointment : null,
    [fabEntryName.CONTACT]: contact,
  }
}
